export const PRD_HOSTNAME = 'zentrains.de';
export const PRD_ENDPOINT = `https://api.${PRD_HOSTNAME}`;
export const DEV_HOSTNAME = `dev.${PRD_HOSTNAME}`;
export const DEV_ENDPOINT = `https://api-${DEV_HOSTNAME}`;
export const LOCAL_ENDPOINT = 'http://localhost:9081';
